"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));
/**
 *
 */


exports.Message = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      isDirty = _a.isDirty;
  return {
    color: isDirty ? theme.palette.danger.text : theme.colorBlack,
    fontFamily: theme.fontText,
    fontSize: theme.size.extraSmall,
    marginTop: theme.x + "px"
  };
});
/**
 *
 */

exports.StyledField = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    .input-wrapper {\n        margin-bottom: 0px;\n    }\n"], ["\n    padding: ", ";\n    .input-wrapper {\n        margin-bottom: 0px;\n    }\n"])), function (_a) {
  var theme = _a.theme,
      margin = _a.margin;
  return margin ? theme.component.margin + " 0px" : 0;
});
var templateObject_1;